import {
  Box,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import GuideStyles from "assets/js/guide";

import "codemirror/lib/codemirror.css";
import "codemirror/theme/dracula.css";
import "codemirror/theme/material.css";

import "codemirror/theme/mdn-like.css";
import "codemirror/theme/the-matrix.css";
import "codemirror/theme/night.css";

import "codemirror/mode/xml/xml";
import "codemirror/mode/javascript/javascript";
import "codemirror/mode/css/css";

import "codemirror/addon/edit/closebrackets";
import "codemirror/addon/edit/closetag";
import { Controlled as ControlledEditor } from "react-codemirror2-react-17";

export default function GuideButton() {
  /* Accordion */
  const [codemirror, setCodemirror] = useState();
  const handleCodemirror = panel => (event, newcodemirror) => {
    setCodemirror(newcodemirror ? panel : false);
  };

  return (
    <>
      <GuideStyles />
      <main id="main" className="container">
        <Box className="box-type-2">
          <div className="h-group">
            <h2 className="guide-h2">Title</h2>
          </div>

          <h3 className="guide-h3">Heading 2</h3>
          <h2 className="h2">h2 - 16px / 700</h2>

          <Accordion
            codemirror={codemirror === "h2"}
            onChange={handleCodemirror("h2")}
            className="accordion-codemirror"
          >
            <AccordionSummary>
              <p>코드보기</p>
            </AccordionSummary>
            <AccordionDetails>
              <ControlledEditor
                value={`<h2 className="h2">h2 - 16px / 700</h2>`}
                className="code-mirror-wrapper"
                options={{
                  lineWrapping: true,
                  lint: true,
                  mode: "xml",
                  theme: "material",
                  lineNumbers: true,
                }}
              />
            </AccordionDetails>
          </Accordion>

          <hr className="guide-hr" />

          <h3 className="guide-h3">Heading 3 - Type 1</h3>
          <h3>h3 - 18px / 700</h3>
          <h3 className="weight800">h3 - 18px / 800</h3>

          <Accordion
            codemirror={codemirror === "h3"}
            onChange={handleCodemirror("h3")}
            className="accordion-codemirror"
          >
            <AccordionSummary>
              <p>코드보기</p>
            </AccordionSummary>
            <AccordionDetails>
              <ControlledEditor
                value={`<h3>h3 - 18px / 700</h3>

<h3 className="weight800">h3 - 18px / 800</h3>
`}
                className="code-mirror-wrapper"
                options={{
                  lineWrapping: true,
                  lint: true,
                  mode: "xml",
                  theme: "material",
                  lineNumbers: true,
                }}
              />
            </AccordionDetails>
          </Accordion>

          <hr className="guide-hr" />

          <h3 className="guide-h3">Heading 3 - Type 2</h3>
          <h3 className="h3">h3 - 24px / 700</h3>

          <Accordion
            codemirror={codemirror === "h3Size24"}
            onChange={handleCodemirror("h3Size24")}
            className="accordion-codemirror"
          >
            <AccordionSummary>
              <p>코드보기</p>
            </AccordionSummary>
            <AccordionDetails>
              <ControlledEditor
                value={`<h3 className="h3">h3 - 24px / 700</h3>`}
                className="code-mirror-wrapper"
                options={{
                  lineWrapping: true,
                  lint: true,
                  mode: "xml",
                  theme: "material",
                  lineNumbers: true,
                }}
              />
            </AccordionDetails>
          </Accordion>

          <hr className="guide-hr" />

          <h3 className="guide-h3">Examples</h3>
          <h3 className="h3 type2">
            탈퇴하시면 <br />
            아래 혜택이 사라져요!
          </h3>
          <Typography className="info-txt" mt={3}>
            회원탈퇴시 보유하고 계신 메가포인트, 상품권 전환금 등은 자동
            소멸되어 복원되지 않습니다.
          </Typography>

          <Accordion
            codemirror={codemirror === "h3Type2"}
            onChange={handleCodemirror("h3Type2")}
            className="accordion-codemirror"
          >
            <AccordionSummary>
              <p>코드보기</p>
            </AccordionSummary>
            <AccordionDetails>
              <ControlledEditor
                value={`<h3 className="h3 type2">
  탈퇴하시면 <br />
  아래 혜택이 사라져요!
</h3>
<Typography className="info-txt" mt={3}>
  회원탈퇴시 보유하고 계신 메가포인트, 상품권 전환금 등은 자동
  소멸되어 복원되지 않습니다.
</Typography>
                `}
                className="code-mirror-wrapper"
                options={{
                  lineWrapping: true,
                  lint: true,
                  mode: "xml",
                  theme: "material",
                  lineNumbers: true,
                }}
              />
            </AccordionDetails>
          </Accordion>
        </Box>
      </main>
    </>
  );
}
